(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["facets"] && !Shopify.designMode) return;
  try {
    // Snippet JS is bundled with every other component, so scope it.
  (function () {
    // Changing the sort order applies immediately; filter checkboxes wait for
    // the Apply button so shoppers can pick several at once.
    document.addEventListener('change', (event) => {
      const control = event.target.closest('[data-facet-auto-submit]');
      if (control) control.closest('form')?.submit();
    });

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;

      const panel = document.querySelector('.facets__mobile-toggle[open]');
      if (panel) {
        panel.open = false;
        panel.querySelector('summary')?.focus();
      }
    });

    document.addEventListener('click', (event) => {
      const panel = document.querySelector('.facets__mobile-toggle[open]');
      if (panel && !panel.contains(event.target)) panel.open = false;
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
